export default async function addJsonTo(headers: Headers) {
  headers.append(`Accept`, `application/json`);
}
